import RemotePaths from '../../../consts/RemotePaths';

/** Duas letras do nome da agenda para o avatar da linha. */
export const resourceInitials = (label) => {
    const words = String(label || '').trim().split(/\s+/).filter(Boolean);
    if (words.length === 0) return '?';
    if (words.length === 1) return words[0].slice(0, 2).toUpperCase();
    return (words[0][0] + words[words.length - 1][0]).toUpperCase();
};

/**
 * Telefone salvo (só dígitos, às vezes com o DDI na frente) no formato de leitura:
 * "+55 (11) 99999-9999". Fora do padrão, devolve o texto como veio.
 */
export const formatResourcePhone = (phone, countryCode) => {
    if (!phone) return '';
    const digits = String(phone).replace(/\D/g, '');
    let ddi = String(countryCode || '').replace(/\D/g, '');
    let local = digits;
    if (digits.length > 11) {
        ddi = digits.substring(0, digits.length - 11);
        local = digits.substring(digits.length - 11);
    }
    if (local.length !== 10 && local.length !== 11) return phone;
    const split = local.length === 11 ? 7 : 6;
    const formatted = `(${local.slice(0, 2)}) ${local.slice(2, split)}-${local.slice(split)}`;
    return ddi ? `+${ddi} ${formatted}` : formatted;
};

/** A agenda tem uma assinatura salva (nome de arquivo com extensão). */
export const hasSignature = (resource) => !!resource?.Signature && resource.Signature.includes('.');

/** URL da assinatura; version muda a cada recarga da lista e evita a imagem antiga em cache. */
export const signatureUrl = (companyId, resource, version) => {
    if (!resource || !resource.Signature) return null;
    return `${RemotePaths.PATH_USER_UPLOADS_COMPANY_RESOURCE_SIGNATURE(companyId)}${resource.Signature}?t=${version}`;
};

/** Link público da agenda no agendamento online. */
export const publicScheduleUrl = (slug) => `${window.location.origin}/agendar/${slug}`;

/** Mesmo slug do backend (makeSlug em set_company_resource.php): minúsculas, sem acento, hífens. */
export const makeResourceSlug = (text) => String(text ?? '')
    .trim()
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');

/**
 * Prévia do link montada pelo nome digitado: {slug da empresa}/{slug do nome}, como o
 * backend gera ao salvar. Sem slug da empresa, o backend usa o id (a empresa 0 existe).
 * Pode ganhar "-2" no fim ao salvar se outra agenda já usa o mesmo nome.
 */
export const previewResourceSlug = (companySlug, companyId, label) => {
    const labelSlug = makeResourceSlug(label);
    if (!labelSlug) return '';
    const base = companySlug || makeResourceSlug(companyId);
    return `${base}/${labelSlug}`;
};
